/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AdminValidationMessageLevel = {
  type: 'Enum',
} as const;
